import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useMemberDetail } from './hooks/useMemberDetail';
import { MemberInfoBlock } from './components/MemberInfoBlock';
import { MemberAccessBlock } from './components/MemberAccessBlock';
import { MemberStatsBlock } from './components/MemberStatsBlock';
import { MemberHistoryBlock } from './components/MemberHistoryBlock';

export function MemberDetailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get('id');
  const { member, logs, isLoading, error } = useMemberDetail(id);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <i className="ri-error-warning-line text-4xl text-rose-500 mb-2" />
        <p className="text-sm font-medium text-slate-600">{error}</p>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 rounded-md border border-slate-100 bg-white px-4 py-2 text-xs font-medium text-slate-700"
        >
          Quay lại
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Header Actions */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 rounded-md border border-slate-100 bg-white px-3 py-1.5 text-xs font-medium text-slate-600 active:scale-95 transition-all"
        >
          <i className="ri-arrow-left-line" />
          Quay lại
        </button>
        <div className="flex items-center gap-2">
           <button className="rounded-md border border-slate-100 bg-white px-3 py-1.5 text-xs font-medium text-slate-600 active:scale-95 transition-all">
             <i className="ri-edit-line mr-1.5" />
             Sửa hồ sơ
           </button>
        </div>
      </div>

      {/* Main Grid Layout */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
        {/* Left Column: Basic Info & Access */}
        <div className="xl:col-span-8 space-y-4">
          <MemberInfoBlock member={member!} isLoading={isLoading} />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <MemberAccessBlock member={member!} isLoading={isLoading} />
             <MemberStatsBlock />
          </div>
        </div>

        {/* Right Column: Activity History */}
        <div className="xl:col-span-4">
          <MemberHistoryBlock logs={logs} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
}
